import { useGetMachinesQuery } from '../../../store/api/machines-api'

export default function useGetDigitalDistributionMachines() {
    return useGetMachinesQuery({
        filters: {
            machine_brand: {
                name: {
                    $in: ['Durst', 'GF'],
                },
            },
        },
        populate: {
            machine_brand: true,
        },
    })
}
